// src/store/contactSlice.js
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { initialState } from '../../data/initialState.customer.data';
import {
  createCustomer as createCustomerAPI,
  fetchCustomer as fetchCustomerAPI,
  updateCustomer as updateCustomerAPI,
  deleteCustomer as deleteCustomerAPI,
} from '../../apis/customerAPIs';
import { handlePending, handleRejection } from '../../constants';

export const addCustomer = createAsyncThunk(
  'customer/addCustomer',
  async (body, { rejectWithValue }) => {
    try {
      const response = await createCustomerAPI(body);
      return response.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const fetchCustomer = createAsyncThunk(
  'customer/fetchCustomer',
  async (body, { rejectWithValue }) => {
    try {
      const response = await fetchCustomerAPI(body);
      return response.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const updateCustomer = createAsyncThunk(
  'customer/updateCustomer',
  async (body, { rejectWithValue }) => {
    try {
      const response = await updateCustomerAPI(body);
      return response.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const deleteCustomer = createAsyncThunk(
  'customer/delete',
  async (body, { rejectWithValue }) => {
    try {
      const response = await deleteCustomerAPI(body);
      return response.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

const customerSlice = createSlice({
  name: 'customer',
  initialState,
  reducers: {
    setCustomer: (state, action) => {
      state.customerForm[action.payload.name] = action.payload.value;
    },
    handleUpdateCustomer: (state, action) => {
      state.customerForm.name = action.payload.name;
      state.customerForm.description = action.payload.description;
      state.customerForm.id = action.payload.id;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(addCustomer.pending, handlePending)
      .addCase(addCustomer.fulfilled, (state, action) => {
        state.loading = true;
        state.customers.push(action.payload);
      })
      .addCase(addCustomer.rejected, handleRejection)

      .addCase(fetchCustomer.pending, handlePending)
      .addCase(fetchCustomer.fulfilled, (state, action) => {
        state.loading = false;
        state.customers = action.payload.reverse();
      })
      .addCase(fetchCustomer.rejected, handleRejection)

      .addCase(deleteCustomer.pending, handlePending)
      .addCase(deleteCustomer.fulfilled, (state, action) => {
        state.loading = false;
        const data = [...state.customers];
        const indexToRemove = data.findIndex(
          (item) => item.id === action.payload
        );
        data.splice(indexToRemove, 1);
        state.customers = [...data];
      })
      .addCase(deleteCustomer.rejected, handleRejection)

      .addCase(updateCustomer.pending, handlePending)
      .addCase(updateCustomer.fulfilled, (state, action) => {
        state.loading = false;
        const newData = state.customers?.map((item) => {
          if (item.id === action.payload.id) {
            return action.payload;
          }
          return item;
        });
        state.customers = newData;
      })
      .addCase(updateCustomer.rejected, handleRejection);
  },
});

export const { setCustomer, handleUpdateCustomer } = customerSlice.actions;

export default customerSlice.reducer;
